import React from 'react';

import classNames from 'classnames/bind';

// Utils
import { Text, Button } from '@beef/ui-kit';
import { Picture, Icon } from 'components';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

export const TableError = ({ text, errorType, handlerUpdateTable }) => (
  <div className={cx('error-container')}>
    {errorType === 'empty'
        && (
        <>
          <Picture defaultImage="https://static.beeline.ru/upload/images/detalization/cat_detalization.svg" />
          <div className={cx('error-container__text')}>
            <Text color="grey95" size="size4-r">
              {text}
            </Text>
          </div>

        </>
        )}
    {errorType === 'serverError'
            && (
            <>
              <Picture className={cx('error-container__img-server-error')} defaultImage="https://static.beeline.ru/upload/images/detalization/socket_error_detalization.svg" />
              <div className={cx('error-container__text')}>
                <Text color="grey95" size="size4-r">
                  Что-то пошло не так, перезагрузите таблицу
                </Text>
                <div className={cx('error-container__button')}>
                  <Button variant="tertiary" type="button" onClick={handlerUpdateTable}>
                    <p>
                      <Icon name="refresh" />
                      {' '}
                      Перезагрузить таблицу
                    </p>
                  </Button>
                </div>
              </div>
            </>
            )}
  </div>
);
